export default __webpack_public_path__ + "acknowledge.92e41e649d78ed97a7a3911f4911adc5.mp3";